import axios from 'axios';
import qs from 'qs';
import store from '../store/index.js';
import router from '../router/index.js'
import webConfig from '../utils/global.config.js'; // whiteListApi 白名单接口数组
import {
	Message
} from 'element-ui'

// 创建axios实例
const request = axios.create({
	baseURL: '/api',
	timeout: 10000,
	responseType: 'json',
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded'
	},
	// 默认表单序列化 ---修改为在需要的地方request({ method:'post', data:qs.stringify(params) })
	// transformRequest: [(data) => {
	// 	return qs.stringify(data);
	// }]
})

// 请求拦截器
request.interceptors.request.use((config) => {
	// 1. 获取白名单接口数组
	const whiteList = webConfig.whiteListApi || [];
	// 2. 判断当前请求接口是否不需要token
	const isWhiteApi = whiteList.some(item => config.url.includes(item));
	// 3. 不在白名单，携带token
	if (!isWhiteApi) {
		const token = store.state.user.token;
		if (token) {
			// 后端token自定义头部，根据你们后端约定修改字段名，如 Authorization / token
			config.headers.token = token;
		}
	}
	return config;
}, (error) => {
	Message.error('请求发起失败');
	return Promise.reject(error);
})

// 响应拦截器
request.interceptors.response.use((response) => {
	const res = response.data; // 后端返回真实数据 {code, msg, data, count}

	// ========== 业务状态码判断，根据你们后端规则调整 ==========
	// code=1 成功
	if (res.code === 1) {
		// 直接返回业务数据，页面调用时直接拿到data
		return res;
	}

	// token过期/未登录 401类错误（和后端确认失效code）
	if (res.code === 401 || res.code === 4001) {
		Message.error('登录已失效，请重新登录');
		// 清空store用户信息
		store.dispatch('user/logout');
		store.dispatch('user/logoutUser');
		// 跳登录页，记录当前页面，登录后回跳
		router.replace({
			path: '/login',
			query: {
				redirect: router.currentRoute.fullPath
			}
		})
		return Promise.reject(res);
	}

	// 其他业务错误 code != 1
	Message.error(res.msg || res.message);
	return Promise.reject(res);

}, (error) => {
	// http层面错误：404、500、超时、断网
	let errMsg = '';
	if (error.message.includes('timeout')) {
		errMsg = '请求超时，请检查网络';
	} else if (!window.navigator.onLine) {
		errMsg = '网络连接失败，请检查网络';
	} else if (error.response) {
		// 有返回状态码
		const status = error.response.status;
		switch (status) {
			case 404:
				errMsg = '接口地址不存在';
				break;
			case 500:
				errMsg = '服务器内部错误';
				break;
			case 403:
				errMsg = '无访问权限';
				break;
			default:
				errMsg = `请求错误${status}`;
		}
	} else {
		errMsg = '服务器连接失败';
	}
	Message.error(errMsg);
	return Promise.reject(error);
})

export default request